(ns teamoesterreich.admin-mode.detail-filter.member-filter
  (:require [reagent-material-ui.components :as mui]
            [teamoesterreich.admin-mode.ui-helper.check-box :refer [filter-check-box onOff-filter-check-box]]
            [clojure.string]
            [goog.date.DateTime]
            [reagent.core :as r]
            [teamoesterreich.util.helper :as h]             ;;(h/event-value e)
            [teamoesterreich.util.log :as log]))







(defn member-block [!detail-search !waiting? !loaded?]



  [mui/grid
   {:item  true
    :xs    12
    :style {:marginBottom "7px"}
    }

   [mui/paper
    [mui/grid
     {:container  true
      :direction  "row"
      :alignItems "flex-start"
      :justify    "flex-start"
      :spacing    1
      :style      {:padding "5px"}
      }

     [mui/grid
      {:item true
       :lg   2
       :md   3
       :xs   6
       }
      [mui/typography "Mitglied"]
      ;[:pre (pr-str @!detail-search)]
      ]
     [mui/grid
      {:item true
       :md   3
       :xs   5
       }
      [mui/form-control
       {
        :component "fieldset"
        :fullWidth true
        }
       [mui/radio-group {:row true :class "filterRadio"}
        [onOff-filter-check-box !waiting? !loaded? !detail-search "Profil vollständig" :filter-profileValid]
        [onOff-filter-check-box !waiting? !loaded? !detail-search "Identität bestätigt" :filter-identityValid]
        [onOff-filter-check-box !waiting? !loaded? !detail-search "Email bestätigt" :filter-emailValid]
        [onOff-filter-check-box !waiting? !loaded? !detail-search "Handy bestätigt" :filter-hdyValid]
        [filter-check-box !waiting? !loaded? !detail-search "Admin" :filter-isAdmin]
        [onOff-filter-check-box !waiting? !loaded? !detail-search "RK Mitglied" :filter-isRk]
        [onOff-filter-check-box !waiting? !loaded? !detail-search "Online Nennungen" :filter-datenOe3]
        [onOff-filter-check-box !waiting? !loaded? !detail-search "Newsletter RK" :filter-infos]
        [onOff-filter-check-box !waiting? !loaded? !detail-search "News Ö3" :filter-infosOe3]

        ]

       ]
      ]
     [mui/grid
      {:item  true
       :md    2
       :xs    4
       :style {:paddingRight "20px"}
       }
      [mui/text-field {
                       :fullWidth       true
                       :InputLabelProps {:disableAnimation true :shrink true}
                       :type            "date"
                       :autoOk          true
                       :format          "dd.MM.yyyy"
                       :label           (str "Anmeldung von")
                       :onChange        (h/wait-do-select !waiting? (fn [val] (swap! !detail-search assoc :filter-since-from val)) !loaded?)
                       :defaultValue    (:filter-since-from @!detail-search)
                       }]

      [mui/text-field {
                       :fullWidth       true
                       :InputLabelProps {:disableAnimation true :shrink true}
                       :type            "date"
                       :autoOk          true
                       :format          "dd.MM.yyyy"
                       :label           (str "Angemeldet bis")
                       :onChange        (h/wait-do-select !waiting? (fn [val] (swap! !detail-search assoc :filter-since-to val)) !loaded?)
                       :defaultValue    (:filter-since-to @!detail-search)
                       }]
      ]
     [mui/grid
      {:item true
       :md   3
       :xs   5
       }
      [mui/form-control
       {
        :component "fieldset"
        :fullWidth true
        }
       [mui/radio-group {:row true :class "filterRadio" :style {:backgroundColor "lightyellow"}}

        [filter-check-box !waiting? !loaded? !detail-search "Identitätsnachweis möglich" :identity-todo]
        [filter-check-box !waiting? !loaded? !detail-search "Fehlende Dienststelle" :orgId-todo]
        [filter-check-box !waiting? !loaded? !detail-search "Aktiver Löschantrag" :delete-request-todo]

        ]

       ]

      ]

     ]]])

